import React, { useEffect } from 'react';
import {createPortal} from 'react-dom';
import {ModalWrap, Overlay, Container, ExitButtonWrapper} from './styles';
import { ExitButton, StyledExitIcon } from '@/components/atoms/UI/ExitButton/styles';

type PropsType = {
    colorful?: boolean
    children: React.ReactNode
    closeModal?: () => void
    unclosed?: boolean
    mode?: any
}

const Modal: React.FC<PropsType> = (props) => {
    const {children, closeModal, unclosed, mode} = props;
    const domEl = document.getElementById('modal-root')
    if (!domEl) return null;

    useEffect(() => {
        if (mode === 'successPrompt' || mode === 'errorPrompt') {
            const timeoutId = setTimeout(() => {
                if (closeModal) {
                    closeModal();
                }
            }, 2000);

            return () => clearTimeout(timeoutId);
        }
    }, [mode, closeModal]);

    return createPortal(
        <ModalWrap>
            <Overlay onClick={unclosed ? () => null : closeModal}/>
            <Container {...props}>
                {!unclosed &&
                    <ExitButtonWrapper>
                        <ExitButton onClick={closeModal}>
                            <StyledExitIcon name='Close' size={7} />
                        </ExitButton>
                    </ExitButtonWrapper>
                }

                {children}
            </Container>
        </ModalWrap>,
        domEl

    )
}

export default Modal